import { observer } from 'mobx-react';
import { Pagination } from '../../../../components/UI/pagination/Pagination';
import { Show } from '../../../../components/UI/show/Show';
import { NewsletterListElement } from './NewsletterListElement';
import {
  NewsletterTableModelType,
  NewsletterListElementModelType,
} from '../../../../internal';
import styles from './NewsletterList.module.scss';

export const NewsletterList = observer(
  (props: {
    model: NewsletterTableModelType;
    noElementsComponent: JSX.Element;
    openNewsletterDetailsPage: (id: number) => void;
    currentPage: any;
    activePaginationPage: number;
    lastPaginationPage: number;
  }): JSX.Element => {
    const {
      model,
      noElementsComponent,
      currentPage,
      activePaginationPage,
      lastPaginationPage,
    } = props;

    const showPagination = model.pagination.totalPages > 1;

    return (
      <div className={styles.Container}>
        <Show condition={!model?.elements?.length}>
          <div className={styles.NoElementsContainer}>
            {noElementsComponent}
          </div>
        </Show>
        <Show condition={model?.elements?.length}>
          {model.elements.map(
            (elem: NewsletterListElementModelType, index: number) => {
              return (
                <NewsletterListElement
                  key={elem.id}
                  model={elem}
                  openNewsletterDetailsPage={props.openNewsletterDetailsPage}
                  currentPage={currentPage}
                  index={index}
                  activePaginationPage={activePaginationPage}
                  lastPaginationPage={lastPaginationPage}
                  naturalIndex={index}
                  currentPageElementCount={model.elements.length}
                />
              );
            }
          )}

          {showPagination && (
            <div className={styles.PaginationOuterContainer}>
              <Pagination model={model.pagination} />
            </div>
          )}
        </Show>
      </div>
    );
  }
);
